import React from 'react'
import Banner from '../Ui/Banner'
import AboutUs from '../Ui/Aboutus'
import HomeService from '../Ui/HomeService'
import WhyChoose from '../Ui/Whychoose'
import Testimonial from '../Ui/Testimonial'

const Main = () => {
  return (
    <div>
           <Banner/>
   <AboutUs/>
   <HomeService/>
   <WhyChoose/>
   <Testimonial/>
    </div>
  )
}

export default Main